import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ServerAction, ServerTranslator } from '@cbridge-packages/server';

type IDependencies = IClientApiDependencySegment;

export const loadServerListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ServerAction.loadList.started),
  mergeMap((params) => {
    return dependencies.api.getServerList({
      nodeId: params.nodeId,
      limit: -1,
    }).pipe(
      mergeMap((response) => {
        const result = (response.servers ?? []).map(ServerTranslator.fromApi);

        return [
          ServerAction.loadList.done({
            params,
            result,
          }),
        ];
      }),
      catchApiError((error) => {
        return [
          ServerAction.loadList.failed({
            params,
            error,
          }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
